<template>
  <div>
    <main-navigation />

    <div class="assign-container">

      <!-- HEADER -->
      <h2 class="page-title" v-if="unit">
        Assign Tenant to Unit
        <span class="text-primary">{{ unit.unit_number }}</span>
        <span class="text-muted" v-if="houseName">
          in {{ houseName }}
        </span>
      </h2>

      <!-- FORM -->
      <div class="card shadow-sm p-4 form-card">

        <!-- TENANT SEARCH -->
        <div class="mb-3 position-relative">
          <label class="form-label fw-semibold">Select Tenant</label>

          <input
            type="text"
            class="form-control form-control-lg"
            v-model="tenantSearch"
            :disabled="selectedTenant"
            placeholder="Start typing tenant name or phone"
          />

          <!-- DROPDOWN -->
          <ul
            v-if="showDropdown"
            class="list-group dropdown-list"
          >
            <li
              v-for="tenant in filteredTenants"
              :key="tenant.id"
              class="list-group-item list-group-item-action"
              @mousedown.prevent="selectTenant(tenant)"
            >
              <strong>{{ tenant.tenant_name }}</strong><br />
              <small class="text-muted">
                {{ tenant.tenant_phone }} • {{ tenant.tenant_idnumber }}
              </small>
            </li>
          </ul>

          <!-- SELECTED TENANT -->
          <div v-if="selectedTenant" class="selected-tenant">
            <strong>{{ selectedTenant.tenant_name }}</strong>
            <span class="text-muted">
              ({{ selectedTenant.tenant_phone }})
            </span>

            <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click="clearTenant"
            >
              Change
            </button>
          </div>
        </div>

        <!-- SUBMIT -->
        <button
          class="btn btn-primary btn-lg w-100"
          :disabled="!selectedTenant || submitting"
          @click="assignTenant"
        >
          {{ submitting ? "Assigning..." : "Assign Tenant" }}
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "AssignTenant",

  data() {
    return {
      unitId: this.$route.params.unitId,

      unit: null,
      houses: [],
      tenants: [],

      tenantSearch: "",
      selectedTenant: null,

      submitting: false
    };
  },

  computed: {
    houseName() {
      if (!this.unit || !Array.isArray(this.houses)) return "";
      const house = this.houses.find(h => h.id === this.unit.house_id);
      return house ? house.name : "";
    },

    filteredTenants() {
      if (!Array.isArray(this.tenants)) return [];

      const key = this.tenantSearch.toLowerCase();

      return this.tenants.filter(t =>
        !t.unit_id && (
          (t.tenant_name || "").toLowerCase().includes(key) ||
          (t.tenant_phone || "").includes(key)
        )
      );
    },

    showDropdown() {
      return (
        this.tenantSearch.length > 0 &&
        !this.selectedTenant &&
        this.filteredTenants.length > 0
      );
    }
  },

  methods: {
    async loadUnit() {
      try {
        const res = await apiFetch(`/unit/${this.unitId}/details`);
        this.unit = res.data || res;
      } catch (err) {
        console.error("Unit load error:", err);
      }
    },

    async loadHouses() {
      try {
        const res = await apiFetch("/houses");
        this.houses = res.data || res;
      } catch (err) {
        console.error("House load error:", err);
        this.houses = [];
      }
    },

    async loadTenants() {
      try {
        const res = await apiFetch("/tenants");
        this.tenants = res.data || res;
      } catch (err) {
        console.error("Tenant load error:", err);
        this.tenants = [];
      }
    },

    selectTenant(tenant) {
      this.selectedTenant = tenant;
      this.tenantSearch = tenant.tenant_name;
    },

    clearTenant() {
      this.selectedTenant = null;
      this.tenantSearch = "";
    },

    async assignTenant() {
      if (!this.selectedTenant) return;

      try {
        this.submitting = true;

        await apiFetch("/assign/unit", {
          method: "POST",
          body: JSON.stringify({
            unitId: this.unitId,
            tenantId: this.selectedTenant.id
          })
        });

        alert("Tenant assigned successfully");
        this.$router.push(`/house/${this.unit.house_id}/units`);

      } catch (err) {
        console.error("Assign error:", err);
        alert(err.message || "Failed to assign tenant");
      } finally {
        this.submitting = false;
      }
    }
  },

  mounted() {
    this.loadUnit();
    this.loadHouses();
    this.loadTenants();
  }
};
</script>

<style scoped>
.assign-container {
  padding: 40px;
  background: var(--dash-bg);
  min-height: calc(100vh - 80px);
}

.page-title {
  font-weight: 700;
  color: var(--dash-primary);
  margin-bottom: 20px;
}

.form-card {
  max-width: 520px;
  margin: auto;
  border-radius: var(--dash-radius-lg);
}

.dropdown-list {
  position: absolute;
  width: 100%;
  z-index: 20;
  max-height: 220px;
  overflow-y: auto;
  border-radius: var(--dash-radius);
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
}

.selected-tenant {
  margin-top: 10px;
  padding: 10px;
  background: var(--dash-primary-soft);
  border-radius: var(--dash-radius-sm);
}
</style>
